













import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import ImagePreview from "@/components/ImagePreview.vue";
import {ImageDto, ImageOrientationDto} from "@swagger";
import ManuallyExpandableImagePreview from "@/components/ManuallyExpandableImagePreview.vue";

@Component({
  components: {ManuallyExpandableImagePreview, ImagePreview}
})
export default class SelectableImagePreview extends BasicComponent {

  @Prop(Boolean) selected: boolean;
  @Prop(Object) image: ImageDto;
  @Prop(String) filter: string;

  openPreview() {
    const ref: ImagePreview = this.$refs.imagePreview as ImagePreview;
    if (!ref) return;
    ref.openDialog();
  }

  onSelect() {
    this.$emit("select");
  }

  get landscape() {
    return this.image.orientation === ImageOrientationDto.LANDSCAPE;
  }

}

